export const appConfig = {
  apiBaseUrl: process?.env?.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "",
};
